<template>
    <div class="search-field">
        <button v-on:click="filter_tab=!filter_tab" style="height:30px;">Filters</button>

        <div class="filter">
            <div v-for="(filter,filter_index) in filter_options" style="display:inline-block">
                <div v-if="filter.name=='Date'">
                    <p
                    v-for="(option, index) in filter.options"
                    v-if="filter_date_values[index]!='' && filter_date_values[index]!=null"
                    style="display:inline-block">
                        {{filter_date_values[index]}},&nbsp;
                    </p>
                </div>
                <div v-else>
                    <p
                    v-for="(option, index) in filter.options"
                    v-if="filter.value[index]==true"
                    style="display:inline-block">
                        {{option}},&nbsp;
                    </p>
                </div>
            </div>
        </div>

        <div v-if="filter_tab==true" class="filter-tab">
            <table>
                <tr v-for="(filter,filter_index) in filter_options">
                    <td>
                        <b>{{filter.name}} :</b>
                    </td>
                    <td>
                        <div v-if="filter.name=='Date'">

                            <div v-for="(option, index) in filter.options" v-if="filter.permission==null || perms.includes(filter.permission[index])">
                                <datetime
                                v-model="filter.value[index]"
                                v-on:input=""
                                style="width:100%"
                                />
                                <label v-bind:for="filter_index+'_'+index">{{option}}</label>
                            </div>

                        </div><div v-else style="display:inline-block;">

                            <div v-for="(option, index) in filter.options" v-if="filter.permission==null || perms.includes(filter.permission[index])">
                                <input style="width:30px" v-bind:id="filter_index+'_'+index" type="checkbox" v-model="filter.value[index]" v-on:click=""></input>
                                <label v-bind:for="filter_index+'_'+index">{{option}}</label>
                            </div>

                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <button v-on:click="apply()" style="height:30px;">Apply</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    name: 'filter',

    props: {
        id: Number,
        filter_options:{
			type:Array,
			required:false,
			default:[]
		},
    },

    data() {
        return {
            perms:[],
			filter_tab:false,
			filter_date_values:[],
        };
    },
    created(){
        this.perms = api.getPerms();
        this.setUp()
    },
    methods: {
        setFilter(update){
            var self = this
            setTimeout(function(){
                var new_filters = []
                for(let i = 0;i<self.filter_options.length;i++){
                    new_filters.push([])
                    for(let j = 0;j<self.filter_options[i].value.length;j++){
                        new_filters[i].push(self.filter_options[i].value[j])
                    }
                }
                
                document.cookie="filter_"+self.id+"="+JSON.stringify(new_filters)+";";
            }, 10);
            this.sendData(update)
        },
        apply(){
            this.setFilter(true);
            this.filter_tab=false;
        },
        sendData(update){
            this.$emit('input',  this.filter_options, update);
        },
        setUp() {
            api.postData(
                {
                    type:"search",
                    data:{
                        pageid:PAGES.LOCAL_OFFICE_FILTER_PAGE,
                    }
                }
            ).then((res) => {
                let index = -1;
                for (let i = 0;i<this.filter_options.length;i++) {
                    if(this.filter_options[i].name == "LocalOffice") {
                        index = i
                        break
                    }
                }

                if(index!=-1) {
                    this.filter_options[index].options = []
                    this.filter_options[index].permission = []
                    this.filter_options[index].value = []

                    let data = res.data.data.column_data;
                    for(let i = 0; i<data.length;i++) {
                        this.filter_options[index].options.push(data[i][0])
                        this.filter_options[index].permission.push(data[i][1])
                        this.filter_options[index].value.push(true)
                    }
                }
            }).finally((res) => {
                
                var cookie = api.getCookie("filter_"+this.id)
                var getFilter = null
                if(cookie!=undefined) {
                    getFilter = JSON.parse(cookie)
                }

                if(getFilter!=null && getFilter.length!=this.filter_options.length){
                    api.eraseCookie("filter_"+this.id);
                    getFilter=null;
                }

                for (let i = 0; i < this.filter_options.length; i++) {
                    if (getFilter != null && getFilter.length > 0) {
                        if (this.filter_options[i].name == "Date") {
                            this.filter_options[i].value = getFilter[i];
                            this.filter_date_values = getFilter[i];
                        } else if (Array.isArray(this.filter_options[i].options)) {
                            const savedValues = getFilter[i];
                            for (let j = 0; j < this.filter_options[i].value.length; j++) {
                                if (j < savedValues.length) {
                                    this.filter_options[i].value[j] = savedValues[j];
                                }
                            }
                        } else {
                            this.filter_options[i].value = getFilter[i];
                        }
                    }
                }

                for(let i = 0;i<this.filter_options.length;i++){
                    if(this.filter_options[i].permission!=null){
                        for(let j = 0;j<this.filter_options[i].permission.length;j++){
                            if(!this.perms.includes(this.filter_options[i].permission[j])){
                                this.filter_options[i].value[j]=false;
                            }
                        }
                    }
                }

                this.setFilter(false)
            })
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/layouts/filter.vue